<template>
  <div class="bg-white mb-3">
    <brb-btn
      v-for="tab in tabs"
      :key="`brb-tab-${tab.id}`"
      :class="{
        activeTab: value === tab.id,
        'border-0 bg-transparent': value !== tab.id
      }"
      :style="`width: ${100 / tabs.length}%;`"
      class="h-100 rounded-0 text-dark py-2"
      size="sm"
      @click="changeActiveTab(tab.id)"
    >
      {{ tab.title }}
    </brb-btn>
  </div>
</template>

<script>
export default {
  name: 'BrbTabs',
  props: {
    tabs: {
      type: Array,
      required: false,
      default: () => []
    },
    value: {
      type: Number,
      required: true
    }
  },
  methods: {
    changeActiveTab(id) {
      this.$emit('input', id)
    }
  }
}
</script>

<style lang="scss">
@import '~/src/assets/scss/abstracts/variables';

.activeTab {
  background-color: white !important;
  color: $brb-green !important;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-bottom: 2px $brb-green solid !important;
  font-weight: 800;
}
</style>
